// src/api/notice.js
import axios from 'axios';
export const getNotices = (params) => axios.post('prod-api/prod-api/procure/page',params,  {
    // export const getNotices = (params) => axios.post('/prod-api/procure/page',params,  {
     // 将 params 作为查询参数传递
    headers: {
        'Content-Type': 'application/json',
        'tenant-id': '0'
    }
});